export default __webpack_public_path__ + "static/media/close-yellow.6a9c6d3b.svg";